import { ITrackingProductPageBaseParameters } from './baseParameters';

export type ITrackingFillMarketingConsentParameters = Pick<
  ITrackingProductPageBaseParameters,
  'marketingConsent'
>;

export const fillMarketingConsent = (
  parameters: ITrackingFillMarketingConsentParameters,
) => {
  const { marketingConsent } = parameters;

  return {
    marketing_consent: marketingConsent ? 'yes' : 'no',
  } as const;
};
